import { CorePressable } from '@/components/Theme/Core/CorePressable';
import { withStyles } from '@/components/Theme/Core/withStyles';

export const ThemePressableRow = withStyles(CorePressable, {style: {flexDirection: 'row'}, type: 'ThemeRow'});
